import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import { useSnackBar } from "../../../../hooks/snackBar";

import { useFormik } from "formik";

import { saveAs } from "file-saver";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import "./styles.scss";

import { Box } from "@mui/system";

import dayjs from "dayjs";
import ButtonYesNo from "../../../../components/ButtonYesNo";
import globals from "../../../../globals";
import TableHeader from "../../../../components/Table/TableHeader";
import {
  alterarPedido,
  detalhePedido,
  gerarExelPedidoDetalhe,
} from "../../../../services/http/pedidosService";
import {
  buscarStatus,
  buscarStatusOferta,
  motivoDaOferta,
} from "../../../../services/http/oportunidadeService";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};



const EditarGestaoPedidos = () => {
  const history = useHistory();
  const { id } = useParams();
  const { addSnackBar } = useSnackBar();
  const [vendedor, setVendedor] = useState("");
  const [validSeller, setValidSeller] = useState(false);
  const [validVenedor, setValidVendedor] = useState(true);
  const [abrirDetProduto, setAbrirDetProduto] = useState(false);
  const [statusDeal, setStatusDeal] = useState(1);
  const [sellers, setSellers] = useState([]);
  const [pedidos, setPedidos] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [tipoList, setTipoList] = useState([]);
  const [statusOfertaList, setStatusOfertaList] = useState([]);
  const [motivoOfertaList, setMotivoOfertaList] = useState([]);
  const formik = useFormik({
    validateOnMount: false,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const handleSalvarPedido = async () => {
    const obj = {
      id: pedidos?.id,
      oportunidadeId: pedidos?.oportunidadeId,
      FeeGreeners: Number(pedidos?.feeGreeners),
      FeeOperLog: Number(pedidos?.feeOperLog),
      TaxaST: Number(pedidos?.taxaSt),
      pedidoItens: pedidos?.pedidoItens.map((item) => {
        return {
          id: item.id,
          pedidoId: item.pedidoId,
          gtinEan: item.gtinEan,
          sku: item.sku,
          totalSolicitado: Number(item.totalSolicitado),
        };
      }),
    };

    try {
      const res = await alterarPedido(obj);
      if (res.fail) {
        if (
          res.errors.indexOf("Url") > -1 ||
          res.errors.indexOf("validar:") > -1
        ) {
          addSnackBar({
            message: res.errors,
            info: "error",
            open: true,
          });
        } else {
          addSnackBar({
            message: "Erro ao tentar atualizar pedido",
            info: "error",
            open: true,
          });
        }
      } else {
        addSnackBar({
          message: "pedido atualizado com sucesso",
          info: "success",
          open: true,
        });

        history.push("/gestaoPedidos");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getNomeFantasiaSeller = () => {
    const response = sellers.find(
      (item) => item?.dadosEmpresaSellerId === pedidos?.dadosEmpresaSellerId
    );
    formik.setFieldValue("nomeFantasia", response?.nomeFantasia);
  };

  const tabelaColunas = [
    "GTIN/EAN*",
    "SKU",
    "Descrição",
    "Lote",
    "Estoque (cx)",
    "Total solicitado",
    "R$ por cx (s/ ST)",
    "Dt. de validade",
    "Taxa ST",
    "Unid. por cx",
    "R$ caixa (c/ ST)",
    "R$ caixa (c/ Fee)",
    "R$ unid. (s/ ST)",
    "R$ unid. (c/ ST)",
    "R$ unid (c/ Fee)",
    "Custo Total (R$)",
    "",
  ];

  const buscarPedido = (pedidoId) => {
    trackPromise(
      detalhePedido(pedidoId).then((res) => {
        const statusPedido = statusList.find(
          (status) => status.id === res.data.statusPedido
        );
        const statusOferta = statusOfertaList.find(
          (status) => status.id === res.data.statusOferta
        );
        const motivoOferta = motivoOfertaList.find(
          (motivo) => motivo.id === res.data.motivoOferta
        );
        console.log(statusOferta);
        setPedidos({
          codigoOportunidade: res.data.codigoOportunidade,
          oportunidadeId: res.data.oportunidadeId,
          codigo: res.data.codigo,
          id: res.data.id,
          dataAbertura: res.data.dataAbertura,
          nome: res.data.nomeCompleto,
          cnpj: res.data.cnpj,
          email: res.data.email,
          celular: res.data.celular,
          tp: res.data.tp,
          feeGreeners: res.data.feeGreeners,
          feeOperLog: res.data.feeOperLog,
          taxaSt: res.data.taxaST,
          pedidoItens: res.data.pedidoItens,
          statusPedido: statusPedido ? statusPedido.id : null,
          statusOferta: statusOferta ? statusOferta.id : null,
          motivoOferta: motivoOferta ? motivoOferta.id : null,
          feeGreenersTotal: res.data.feeGreenersTotal,
          taxaOperacao: res.data.taxaOperacao,
          custoTotal: res.data.custoTotal,
          substituicaoTributario: res.data.substituicaoTributario,
          custoTotalSemST: res.data.custoTotalSemST,
        });

        if (res.fail) {
          throw new Error(res.errors);
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Não foi possível encontrar a pedido.",
        info: "error",
        open: true,
      });
      console.log(error);
    });
  };
  const listarStatus = () => {
    trackPromise(
      buscarStatus().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        } else {
          console.log(res.data);
          setStatusList(res.data);
        }
      })
    ).catch(() => {
      setStatusList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };

  const listarStatusOferta = () => {
    trackPromise(
      buscarStatusOferta().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        } else {
          setStatusOfertaList(res.data);
        }
      })
    ).catch(() => {
      setStatusOfertaList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };
  const listarMotivoOferta = () => {
    trackPromise(
      motivoDaOferta().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        } else {
          setMotivoOfertaList(res.data);
        }
      })
    ).catch(() => {
      setMotivoOfertaList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };

  useEffect(() => {
    if (id) {
      buscarPedido(id);
    }
  }, [id, statusList, statusOfertaList, motivoOfertaList]);

  useEffect(() => {
    Promise.all([
      listarStatus(),
      listarStatusOferta(),
      listarMotivoOferta(),
    ]).catch((error) => {
      console.log(error);
    });
  }, []);

  useEffect(() => {
    if (pedidos?.dadosEmpresaSellerId && sellers.length) {
      getNomeFantasiaSeller();
    }
  }, [pedidos?.dadosEmpresaSellerId, sellers]);

  const extrairBase = () => {
    trackPromise(
      gerarExelPedidoDetalhe(id).then((res) => {
        if (res.data) {
          saveAs(res.data, "Pedidos.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base de pedido",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base de pedido",
        info: "error",
        open: true,
      });
    });
  };

  return (
    <div>
      <div className="row mt20 mb30">
        <div className="col-md-12 titulo">Pedidos de Compra</div>
        <div className="col-md-12 font-thin">
          <strong>Detalhe do Pedido</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3">
          ID da Oportunidade <br />
          <strong>
            {pedidos.codigoOportunidade?.toString()?.padStart(6, "0")}
          </strong>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          Nº
          <br />
          <strong>{pedidos.codigo?.toString()?.padStart(6, "0")}</strong>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          Data de Abertura <br />
          <strong>{dayjs(pedidos?.dataAbertura).format("DD/MM/YYYY")}</strong>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Status do pedido*
            </InputLabel>
            <Select
              key={pedidos.statusPedido}
              className="select"
              variant="outlined"
              label="Status Deal *"
              id="statusPedido"
              MenuProps={MenuProps}
              value={pedidos.statusPedido}
              disabled
            >
              {statusList.map((item) => (
                <MenuItem key={item.id} value={item.id} disabled>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="row mt30 mb20">
        <div className="col-md-12 body">
          <strong>Dados do Comprador</strong>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              name="nome"
              id="nome"
              variant="outlined"
              disabled={true}
              size="small"
              label="Nome"
              className="solid"
              value={pedidos.nome}
            />
          </FormControl>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              name="cnpj"
              id="cnpj"
              variant="outlined"
              size="small"
              label="CNPJ"
              className="solid"
              value={pedidos.cnpj}
              disabled={true}
            />
          </FormControl>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              name="email"
              id="email"
              variant="outlined"
              disabled={true}
              size="small"
              label="E-mail"
              className="solid"
              value={pedidos.email}
            />
          </FormControl>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              name="celular"
              id="celular"
              variant="outlined"
              disabled={true}
              size="small"
              label="Celular"
              className="solid"
              value={pedidos.celular}
            />
          </FormControl>
        </div>
      </div>

      <div className="row mt30 mb20">
        <div className="col-md-12 body">
          <strong>Detalhes da Pedido</strong>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              label="TP*"
              type="text"
              size="small"
              id="nomeOportunidade"
              name="nomeOportunidade"
              variant="outlined"
              value={pedidos.tp}
              disabled
            />
          </FormControl>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Motivo da Oferta*
            </InputLabel>
            <Select
              key={pedidos.motivoOferta}
              className="select"
              variant="outlined"
              label="Motivo da Oferta*"
              id="motivoOferta"
              MenuProps={MenuProps}
              value={pedidos.motivoOferta}
              disabled
            >
              {motivoOfertaList.map((item) => (
                <MenuItem key={item.id} value={item.id} disabled>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Status da Oferta*
            </InputLabel>
            <Select
              key={pedidos.statusOferta}
              className="select"
              variant="outlined"
              label="Status da Oferta*"
              id="statusOferta"
              MenuProps={MenuProps}
              value={pedidos.statusOferta}
              disabled
            >
              {statusOfertaList.map((item) => (
                <MenuItem key={item.id} value={item.id} disabled>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              label="Taxa de Greeners (%)"
              type="number"
              size="small"
              id="taxaGreeners"
              name="taxaGreeners"
              variant="outlined"
              value={pedidos.feeGreeners}
              onChange={(e) =>
                setPedidos({
                  ...pedidos,
                  feeGreeners: e.target.value,
                })
              }
            />
          </FormControl>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              label="Taxa de registro de operação (%)"
              type="number"
              size="small"
              id="taxaOperacao"
              name="taxaOperacao"
              variant="outlined"
              value={pedidos.feeOperLog}
              onChange={(e) =>
                setPedidos({
                  ...pedidos,
                  feeOperLog: e.target.value,
                })
              }
            />
          </FormControl>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              InputLabelProps={{
                shrink: true, // Isso garante que o label fique levantado
              }}
              label="Taxa ST (Oportunidade)"
              type="number"
              size="small"
              id="taxaSt"
              name="taxaSt"
              variant="outlined"
              value={pedidos.taxaSt}
              onChange={(e) =>
                setPedidos({
                  ...pedidos,
                  taxaSt: e.target.value,
                })
              }
            />
          </FormControl>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mt20">
          <div className="table-responsive">
            <table className="table">
              <TableHeader
                style={{ whiteSpace: "nowrap" }}
                columns={tabelaColunas}
              />
              <tbody>
                {pedidos.pedidoItens?.length === 0 ? (
                  <tr>
                    <td colSpan="7">Sem Registros</td>
                  </tr>
                ) : (
                  pedidos.pedidoItens?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.gtinEan || ""}</td> {/* GTIN/EAN */}
                      <td>{item.sku || ""}</td> {/* SKU */}
                      <td>{item.descricaoCurta || ""}</td> {/* Descrição */}
                      <td>{item.lote || ""}</td> {/* Lote */}
                      <td>{item.estoqueDisponivelCaixas || ""}</td>{" "}
                      <td>
                        <TextField
                          InputLabelProps={{
                            shrink: true, // Isso garante que o label fique levantado
                          }}
                          type="number"
                          size="small"
                          id={`totalSolicitado_${index}`}
                          name={`totalSolicitado_${index}`}
                          variant="outlined"
                          InputProps={{
                            style: {
                              backgroundColor: "white",
                            },
                          }}
                          value={item.totalSolicitado || ""}
                          onChange={(e) =>
                            setPedidos({
                              ...pedidos,
                              pedidoItens: pedidos.pedidoItens.map(
                                (item2, index2) =>
                                  index2 === index
                                    ? {
                                        ...item2,
                                        totalSolicitado: e.target.value,
                                      }
                                    : item2
                              ),
                            })
                          }
                        />
                      </td>
                      {/* Estoque (cx) */}
                      <td>
                        {item.valorCaixaComST?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* R$ por cx (s/ ST) */}
                      <td>{item.dataValidade || ""}</td> {/* Dt. de validade */}
                      <td>{item.taxaST || ""}</td> {/* Taxa ST */}
                      <td>{item.quantidadePorCaixa || ""}</td>{" "}
                      {/* Unid. por cx */}
                      <td>
                        {item.valorCaixaComST?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* R$ caixa (c/ ST) */}
                      <td>
                        {item.valorCaixaComFee?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* R$ caixa (c/ Fee) */}
                      <td>
                        {item.valorUnidadeSemST?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* R$ unid. (s/ ST) */}
                      <td>
                        {item.valorUnidadeComST?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* R$ unid. (c/ ST) */}
                      <td>
                        {item.valorUnidadeComFee?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* R$ unid (c/ Fee) */}
                      <td>
                        {item.totalCusto?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || ""}
                      </td>{" "}
                      {/* Custo Total (R$) */}
                      <td></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row d-flex justify-content-end mt20">
        <table
          style={{
            borderCollapse: "collapse",
            width: "30%",
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  fontWeight: "bold",
                }}
              >
                Custo Total (sem ST):
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                {pedidos?.custoTotalSemST?.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                Substituição Tributária:
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                {pedidos?.substituicaoTributario?.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                Fee Operador Logístico:
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                {pedidos?.feeOperLog?.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                Fee Greeners:
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                {pedidos?.feeGreenersTotal?.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  fontWeight: "bold",
                }}
              >
                Custo Total (R$):
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {pedidos?.custoTotal?.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-md-4">
          <button
            onClick={extrairBase}
            className="buton-green btn btn-block btn-lg"
            style={{ marginTop: "10px" }}
          >
            EXTRAIR PEDIDO EM EXCEL
          </button>
        </div>
      </div>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        className="mt40"
      >
        <div className="col-md-8 buttons">
          <ButtonYesNo
            buttonText="CANCELAR"
            buttonClass="col-md-6 buton-white-black-border"
            alertDescription="Deseja realmente descartar as alterações realizadas?"
            onConfirm={() => history.push("/gestaoPedidos")}
          />

          <div className="ml5"></div>
          <button
            type="submit"
            className="col-md-6 button-black "
            onClick={handleSalvarPedido}
          >
            SALVAR
          </button>
        </div>
      </Box>
    </div>
  );
};

export default EditarGestaoPedidos;
